import apiConfig from "constants/apiConfig";
// import { InfluencerInsights, Posts } from "types/influencer";
import axiosClient from "utils/axiosClient";

export const fetchLatestInfluencerSocialMedia = async (socialAccountId: string, entity_id?: string) => {
    const response = await axiosClient.post(apiConfig.FETCH_LATEST_SOCIAL_MEDIA.url.replace('<socialAccountId>', socialAccountId), {...(entity_id ? {entity_id} : {})});
    return response.data;
}

export const fetchBasicSocialPost = async (postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_BASIC_SOCIAL_POST.url
        .replace('<postId>', postId)
    )
    return response.data.social_post;
}

export const fetchSocialPost = async (socialAccountId: string, socialPostId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POST.url
        .replace('<socialAccountId>', socialAccountId)
        .replace('<socialPostId>', socialPostId)
    )
    return response.data.social_post;
}


export const fetchSocialAccount = async (socialAccountId: string) => {
    const response = await axiosClient.get(
        apiConfig.FETCH_SOCIAL_ACCOUNT.url.replace('<socialAccountId>', socialAccountId)
    );
    return response.data;
};

export const fetchSocialAccountApplications = async (socialAccountId: string) => {
    const response = await axiosClient.get(
        apiConfig.FETCH_SOCIAL_ACCOUNT_APPLICATIONS.url.replace('<socialAccountId>', socialAccountId)
    );
    return response.data;
};

export const fetchSocialAccountCollaborations = async (socialAccountId: string) => {
    const response = await axiosClient.get(
        apiConfig.FETCH_SOCIAL_ACCOUNT_COLLABORATIONS.url.replace('<socialAccountId>', socialAccountId)
    );
    return response.data;
};

export const fetchSocialPosts = async (
    socialAccountId: string,
    payload: {
        page: number;
        sort?: string;
        limit?: number;
        has_brand_collabs?: 'y';
        type?: string;
    } = { page: 1 }
) => {
    const response = await axiosClient.get(
        apiConfig.FETCH_SOCIAL_POSTS.url.replace('<socialAccountId>', socialAccountId),
        { params: { ...payload, limit: payload.limit ?? 15 } }
    );
    return response.data;
};

export const onboardCreator = async (socialAccountId: string, agent?: string, campaignId?: string): Promise<string> => {
    const response = await axiosClient.post(
        apiConfig.ONBOARD_CREATOR.url.replace('<socialAccountId>', socialAccountId),
        { ...(agent ? { agent } : {}), ...(campaignId ? { campaign_id: campaignId } : {}) }
    );
    return response.data?.text ?? '';
};

export const replyCreatorDm = async (
    socialAccountId: string,
    sessionId: string,
    message: string
) => {
    const response = await axiosClient.post(
        apiConfig.REPLY_CREATOR_DM.url
            .replace('<socialAccountId>', socialAccountId)
            .replace('<sessionId>', sessionId),
        { message }
    );
    return response.data;
};
